/* eslint-disable vuejs-accessibility/anchor-has-content */
<template>
    <div>
        <nav class="top-nav navbar-dark">
            <div class="container">
                <ul class="list-inline">
                    <li class="list-inline-item">
                        <a class="nav-link" href="/contact-us">{{ $t('layout.header.contactUs') }}</a>
                    </li>
                    <li class="list-inline-item">
                        <a class="nav-link" :href="`tel:${tel}`">{{ telDisplay }}</a>
                    </li>
                    <li class="list-inline-item">
                        <a class="nav-link" :href="`mailto:${emailContact}`">{{ emailContact }}</a>
                    </li>
                </ul>
            </div>
        </nav>
        <nav class="navbar navbar-expand-lg navbar-light p-3 sticky-top bg-white shadow-sm">
            <div class="container">
                <a class="navbar-brand" href="/">
                    <img :src="headerLogoPath" width="200" alt="morgan" />
                </a>

                <Broker v-if="$broker" />

                <LocaleChanger />
            </div>
        </nav>
    </div>
</template>

<script>
import helper from '../../utils/helper'
import applyOnlineService from '../../api/services/applyOnlineService'
import LocaleChanger from '../LocaleChanger'
import Broker from './Broker.vue'

export default {
    // eslint-disable-next-line vue/no-reserved-component-names
    name: 'Header',
    components: {
        LocaleChanger,
        Broker,
    },
    data() {
        return {
            showMenu: false,
            basePath: helper.getBaseAssetPath(),

            tel: '',
            telDisplay: '',
            emailContact: '',
            headerLogoPath: '',
        }
    },
    mounted() {
        // set config layout
        applyOnlineService.getSpecificConfigLayoutAsync().then((result) => {
            this.tel = result.tel
            this.telDisplay = result.telDisplay
            this.emailContact = result.emailContact
            this.headerLogoPath = this.basePath + result.headerLogoPath
        })
    },
    methods: {
        toggleMenu() {
            this.showMenu = !this.showMenu
        },
    },
}
</script>